import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('schulung_token');
    const stored = localStorage.getItem('schulung_user');
    if (token && stored) {
      setUser(JSON.parse(stored));
      // Verify token is still valid
      api.get('/auth/me').then(res => {
        setUser(res.data);
        localStorage.setItem('schulung_user', JSON.stringify(res.data));
      }).catch(err => {
        if (err.response?.status === 401) {
          localStorage.removeItem('schulung_token');
          localStorage.removeItem('schulung_user');
          setUser(null);
        }
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  async function login(email, password) {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('schulung_token', res.data.token);
    localStorage.setItem('schulung_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }

  function logout() {
    api.post('/auth/logout').catch(() => {});
    localStorage.removeItem('schulung_token');
    localStorage.removeItem('schulung_user');
    setUser(null);
    window.location.href = '/login';
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
